import React, { useMemo, useState } from 'react';
import { calculateQuote } from '../utils/pricing';
import BookingCalendar from './BookingCalendar';
import BookingSummary from './BookingSummary';
import BookingForm from './BookingForm';
import Reveal from './Reveal';
import './Booking.css';

/**
 * Rezervačná sekcia: kalendár + kalkulačka + formulár.
 * Na desktope je súhrn ceny „prilepený" a viditeľný počas scrollovania.
 */
export default function BookingSection({ occupiedSet, status }) {
  const [startKey, setStartKey] = useState(null);
  const [endKey, setEndKey] = useState(null);
  const [extraIds, setExtraIds] = useState([]);
  const [discount, setDiscount] = useState({ code: '', percent: 0, voucher: 0 });

  const quote = useMemo(() => {
    if (!startKey || !endKey) return null;
    return calculateQuote(startKey, endKey, extraIds, discount.percent, discount.voucher);
  }, [startKey, endKey, extraIds, discount]);

  const handleDatesChange = (nextStart, nextEnd) => {
    setStartKey(nextStart);
    setEndKey(nextEnd);
  };

  const toggleExtra = (id) => {
    setExtraIds((previous) =>
      previous.includes(id)
        ? previous.filter((extraId) => extraId !== id)
        : [...previous, id]
    );
  };

  return (
    <section className="section section--gray" id="rezervacia">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Rezervácia</span>
          <h2>Vyber si termín</h2>
          <p className="lead">
            Kalendár zobrazuje aktuálnu obsadenosť. Vyber deň vyzdvihnutia a
            vrátenia – cena sa spočíta automaticky.
          </p>
        </Reveal>

        <div className="booking">
          <div className="booking__main">
            <Reveal>
              <BookingCalendar
                occupiedSet={occupiedSet}
                status={status}
                startKey={startKey}
                endKey={endKey}
                onChange={handleDatesChange}
              />
            </Reveal>

            {/* Súhrn pre mobil – na desktope ho nahrádza lepiaca karta vpravo */}
            <div className="booking__summary-mobile">
              <BookingSummary
                startKey={startKey}
                endKey={endKey}
                quote={quote}
                extraIds={extraIds}
                onToggleExtra={toggleExtra}
                discount={discount}
                onDiscountChange={setDiscount}
              />
            </div>

            <Reveal>
              <BookingForm
                startKey={startKey}
                endKey={endKey}
                quote={quote}
                discountCode={discount.code}
              />
            </Reveal>
          </div>

          <aside className="booking__aside" aria-label="Súhrn rezervácie">
            <div className="booking__sticky">
              <BookingSummary
                startKey={startKey}
                endKey={endKey}
                quote={quote}
                extraIds={extraIds}
                onToggleExtra={toggleExtra}
                discount={discount}
                onDiscountChange={setDiscount}
              />
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
